<template lang="pug">
.designer
  .container-fluid
    .row.px-0
      .col-sm-12.px-0
        img.w-100.firstBanner.img-fluid(:src="designerMaster[0].designerBannerImg" v-if="designerMaster[0]")
  .container.mt-3
    .row.align-items-center
      .col-md-3.h-100
        .d-flex.justify-content-center.h-100.align-items-center
          img(:src="designerMaster[0].designerIcon" v-if="designerMaster[0]").img-fluid.rounded-circle
      .col-md-9.h-100.d-flex.flex-column.justify-content-center
        p.titleFont(v-if="designerMaster[0]") {{designerMaster[0].designerName}}
        p.designerDesc(v-html="designerMaster[0].designerDesc" v-if="designerMaster[0]")
    hr
    p.titleFont.text-center.my-5 主題精選
    //- 篩選大類
    .d-flex.justify-content-center.mb-3.flex-wrap
      .d-flex.flex-column.align-items-center.mx-4.categoryItem(v-for="item in designerProductCategory"  :class="{'opacity' : selectedCategoryId !== item.categoryId}" @click="changeCategory(item.categoryName, item.categoryId)")
        img(:src="item.categoryIcon")
        p.mb-0 {{item.categoryName}}
    //- 202307 Isabel
    .d-flex.justify-content-between.align-items-center
      p.mb-0.font-weight-bold.categoryText(@click="badgeShowOrnot = !badgeShowOrnot") {{selectedCategoryItem}} <i class="fas fa-angle-down" v-if="!badgeShowOrnot"></i> <i class="fas fa-angle-up" v-if="badgeShowOrnot"></i>
      p.mb-0.font-weight-bold 共<span class="text-primary">{{renderProductItem.length}}</span>件商品
    hr
    //- badge 篩選Content
    .d-flex.justify-content-center(v-if="designerId === 702") <p style="color: red; font-weight: bold">彌月卡訂單成立隔天起算5個工作天出貨</p>，例假日、國定假日與補班日不算工作天，送禮前請預留時間提早下單。
    .d-flex.align-items-center.mb-3(v-if="badgeShowOrnot")
      .badgeContent.text-center.mx-1(v-for="item in designerProducts" v-if="selectedCategoryId === '' || selectedCategoryId === item.categoryId" @click="selectedProductId = item.productId") {{item.productName}}
    //- designer product item
    //- 20221214 企業合作商品
    .row.pb-5.moreChoicePicBox.justify-content-start(v-if="actionMode === '0' && designerId !== 702")
      a(v-for="item in renderProductItem" :href="item.editLink" :key="item.Id").col-md-3.col-6.d-flex.justify-content-center.mb-md-4.text-decoration-none.flex-wrap
        .card
          .imgBox
            img.card-img-top(:src="item.imgcover")
            //- img.card-img-top(src="https://fakeimg.pl/256/")
        .card-body
            //- p.mb-0.productName.text-center {{item.productName}}
            h5.card-title.font-weight-bold.text-secondary.text-center {{item.templateName}}
    //- 依莎貝爾 黑底暫除
    .row.pb-5.moreChoicePicBox.justify-content-start(v-if="actionMode === '0' && designerId === 702")
      a(href="#exampleModal" v-for="(item, index) in renderProductItem" :key="item.Id" data-toggle="modal" data-target="#exampleModal" @click="showItem(index)").col-md-3.col-6.d-flex.justify-content-center.mb-md-4.text-decoration-none.flex-wrap
        .card
          .imgBox
            img.card-img-top(:src="item.imgcover")
            //- img.card-img-top(src="https://fakeimg.pl/256/")
        .card-body
            //- p.mb-0.productName.text-center {{item.productName}}
            h5.card-title.font-weight-bold.text-secondary.text-center {{item.templateName}}

      //- modal Isabel editor
      div(id="exampleModal" v-for="item in renderProductItem" tabindex="-1"
      role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true").modal.fade
        div(v-if="fullWidth > 900").modal-dialog(role="document").modal-sm
          div.modal-content
            div.modal-header
              h5.modal-title(id="exampleModalLabel") 編輯提醒
              button(type="button", data-dismiss="modal", aria-label="Close").close
                  span(aria-hidden="true") &times;
            div.modal-body.text-center
              img(v-if="selectedItem.categoryId === 9", src="/static/img/Isabel_pc.png").img-fluid
              img(v-else, src="/static/img/editordes_festival.jpg").img-fluid
            div.modal-footer
                a(:href="selectedItem.editLink").btn.btn-primary.font-weight-bold.btnInPage.py-0.text-white 開始製作

        div(v-else).modal-dialog(role="document").modal-md
          div.modal-content
            div.modal-header
              h5.modal-title(id="exampleModalLabel") 編輯提醒
              button(type="button", data-dismiss="modal", aria-label="Close").close
                  span(aria-hidden="true") &times;
            div.modal-body.text-center
              img(v-if="selectedItem.categoryId === 9",src="/static/img/Isabel_mobile.png").img-fluid
              img(v-else, src="/static/img/editordes_festival.jpg").img-fluid
            div.modal-footer
                a(:href="selectedItem.editLink").btn.btn-primary.font-weight-bold.btnInPage.py-0.text-white 開始製作

    //- 20221214 一般商品
    .row.pb-5.moreChoicePicBox.justify-content-start(v-if="actionMode === '1'")
      div(v-for="item in renderProductItem" :key="item.Id" @click.prevent="goDesignerItemPage(item.Id)").col-md-3.col-6.d-flex.justify-content-center.mb-md-4.text-decoration-none
        .card
          .imgBox
            img.card-img-top(:src="item.imgcover")
            //- img.card-img-top(src="https://fakeimg.pl/256/")
          .card-body
            //- p.mb-0.productName.text-center {{item.productName}}
            h5.card-title.font-weight-bold.text-secondary.text-center {{item.templateName}}
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {
  },
  data () {
    return {
      selectedCategoryItem: '全部商品',
      cardBabyBirth: '彌月卡',
      cardGreetings: '賀卡',
      selectedCategoryId: '',
      selectedProductId: '',
      renderProductItem: [],
      badgeShowOrnot: false,
      fullWidth: document.body.clientWidth,
      selectedItem: {}
    }
  },
  async created () {
    const vm = this
    let id = vm.$route.params.id
    let designerId = vm.$route.params.designerId
    await vm.$store.dispatch('getDesignerDetail', { id, designerId })
    vm.renderProductItem = vm.designerProductItem
  },
  computed: {
    ...mapState({
      designerMaster: (state) => state.designerModules.designerMaster,
      designerProductItem: (state) => state.designerModules.designerProductItem,
      designerProducts: (state) => state.designerModules.designerProducts,
      designerProductCategory: (state) =>
        state.designerModules.designerProductCategory,
      shopCode: (state) => state.commonShopModules.shopCode,
      productionMode: (state) => state.commonShopModules.productionMode,
      actionMode: (state) => state.designerModules.actionMode,
      designerId: (state) => state.designerModules.designerId

    })
  },
  mounted () {
    // 2022/10/26, jamei
    const vm = this
    vm.$store.dispatch('getShopCode')
    vm.$store.dispatch('getProductionMode', { shopCode: vm.shopCode })
  },
  watch: {
    // 當url改變時可重複render同一個component
    async $route (to, from) {
      const vm = this
      let id = vm.$route.params.id
      let designerId = vm.$route.params.designerId
      if (
        to.params.id !== from.params.id ||
        to.params.designerId !== from.params.designerId
      ) {
        await vm.$store.dispatch('getDesignerDetail', { id, designerId })
        // vm.selectedProductId = vm.designerProducts[0].productId
        vm.selectedCategoryItem = '全部商品'
        vm.renderProductItem = vm.designerProductItem
        vm.selectedCategoryId = ''
        vm.selectedProductId = ''
      }
    },
    // 選大類重新render
    selectedCategoryId () {
      let vm = this
      let renderProductItem = []
      if (vm.selectedCategoryId === '') {
        renderProductItem = vm.designerProductItem
      } else {
        vm.designerProductItem.forEach((item) => {
          if (vm.selectedCategoryId === item.categoryId) {
            renderProductItem.push(item)
          }
        })
      }
      vm.renderProductItem = renderProductItem
    },
    // 選product重新render
    selectedProductId () {
      let vm = this
      let renderProductItem = []
      if (vm.selectedProductId !== '') {
        vm.designerProductItem.forEach((item) => {
          if (item.productId === vm.selectedProductId) {
            renderProductItem.push(item)
          }
        })
      } else {
        renderProductItem = vm.designerProductItem
      }

      vm.renderProductItem = renderProductItem
    }
  },
  methods: {
    changeCategory (categoryName, categoryId) {
      let vm = this
      vm.selectedCategoryItem = categoryName
      vm.selectedCategoryId = categoryId
    },
    designerItem (designerItemId, shopCode) {
      console.log(
        '[designerItem] designerItemId=' +
          designerItemId +
          ', shopCode=' +
          shopCode
      )
      if (
        shopCode !== null &&
        typeof shopCode !== 'undefined' &&
        shopCode !== ''
      ) {
        this.$router
          .push(`${shopCode}/designerItem/${designerItemId}`)
          .catch((err) => {
            if (err.name === 'NavigationDuplicated') window.location.reload()
          })
      } else {
        this.$router.push(`/designerItem/${designerItemId}`).catch((err) => {
          if (err.name === 'NavigationDuplicated') window.location.reload()
        })
      }
    },
    goDesignerItemPage (designerItemId, shopCode) {
      this.designerItem(designerItemId, shopCode)
    },
    showItem (index) {
      this.selectedItem = this.renderProductItem[index]
    },
    showItemIsabel (index) {
      this.selectedItem = this.renderProductItem.slice(8, 16)[index]
    }
  }
}
</script>

<style lang="scss" scoped>
$s20: 20px;
$serif: "Microsoft JhengHei", "Noto Serif TC", serif, Apple Color Emoji,
  Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
.titleFont {
  font-size: 24px;
  font-family: $serif;
  font-weight: bold;
}
hr {
  border-color: black;
}
.designerDesc {
  line-height: 26px;
  font-family: $serif;
}
// first banner
.firstBanner {
  width: 100%;
  max-height: 700px;
  height: auto;
  position: relative;
  z-index: 0;
}

@media (max-width: 640px) {
  .firstBanner {
    height: auto;
  }
}
.categoryItem {
  cursor: pointer;
  &.opacity {
    opacity: 0.4;
  }
  img {
    max-width: 90px;
  }
}
.categoryText {
  cursor: pointer;
}
.badgeContent {
  border: 2px solid black;
  padding: 5px 10px;
  box-sizing: border-box;
  border-radius: 5px;
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;
}
// TODO 20221111
.badgeContent:hover {
  color: white;
  background-color: black;
  cursor: pointer;
}
// template
.card {
  max-height: 320px;
  max-width: 258px;
  box-sizing: border-box;
  cursor: pointer;
  .productName {
    font-size: 14px;
  }
  &:hover {
    .imgBox,
    .card-body {
      opacity: 0.5;
    }
  }
}
@media (max-width: 640px) {
  .card {
    margin-bottom: 46px;
  }
}
// 設定col-md-4的寬度
@media (min-width: 640px) {
  .moreChoicePicBox {
    justify-content: center;
    .col-md-4 {
      max-width: 28%;
    }
  }
}
@media (max-width: 640px) {
  .moreChoicePicBox {
    justify-content: center;
  }
}

// template  相片下方  白色部分
.card-body {
  height: 64px;
  box-sizing: border-box;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  h5 {
    margin-bottom: 0;
  }
}
@media (max-width: 640px) {
  .card-body {
    height: 40px;
    padding: 0px 0;
    font-size: 24px;
    h5 {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.6em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/designer.vue